import { useIsMutating } from '@tanstack/react-query';
import { useEffect } from 'react';

/**
 * While a write is in flight, closing or reloading the tab would lose it
 * silently; asking the browser to confirm gives the request its moment.
 * The browser shows its own wording, so there is none here.
 */
export function useUnloadGuardWhileSaving(): void {
  const mutating = useIsMutating();
  const saving = mutating > 0;
  useEffect(() => {
    if (!saving) {
      return;
    }
    const onBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, [saving]);
}
